import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, Effect } from '@ngrx/effects';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/exhaustMap';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/take';
import { AuthService } from '../auth/shared/services/auth.service';
import { HttpClient } from '@angular/common/http';



@Injectable()
export class AppEffects {
  @Effect({dispatch: false})
  error$ = this.actions$.do(a => {
    this.http.post(`https://us-central1-spaq-156518.cloudfunctions.net/log`, {data: a}).subscribe(
      data => {
        console.log(data);
      });
  });

  constructor(
    private actions$: Actions,
    private authService: AuthService,
    private router: Router,
    private http: HttpClient
  ) {
  }
}



// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/effects/app.effects.ts